export default function isDev() {
  return Boolean(process.env.NODE_ENV === "development");
}
